import type { FocusEvent } from "react";

export const getNextValue = (
  itemValue: string,
  { value, allowDeselect }: { value?: string; allowDeselect?: boolean }
) => (value === itemValue && allowDeselect ? undefined : itemValue);

export const handleGroupBlur =
  (onBlur?: () => void) => (event: FocusEvent<HTMLElement>) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      onBlur?.();
    }
  };
